export const adminrefreshToken = async () => {
    const email = localStorage.getItem("user_email");
    const password = localStorage.getItem("user_password");

    if (!email || !password) return null;

    try {
        const res = await fetch("http://62.72.43.31:3000/user/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authkey": "7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3",
            },
            body: JSON.stringify({
                user_email: email,
                password: password,
            }),
        });

        const data = await res.json();

        if (res.ok && data.token) {
            localStorage.setItem("auth_token", data.token);
            return data.token;
        }

        return null;
    } catch (err) {
        console.error("Token refresh failed", err);
        return null;
    }
};